module.exports = __webpack_public_path__ + "static/media/cellwine-logo.d064fa22.svg";